import React from "react";
import { Routes, Route } from "react-router-dom";
import Typography from "../../Utility/Typography";
import ComingSoon from "../../Utility/ComingSoon/ComingSoon";
import { RiSettingsLine } from "react-icons/ri";

const Settings = () => {
  return (
    <div className="w-full">
      <Routes>
        <Route
          index
          element={
            <div>
              <Typography variant="h4" className="mb-4 text-theme-primary">
                Settings
              </Typography>
              <div className="bg-surface-primary rounded-md border border-border-primary shadow-sm p-6">
                {/* <p className="text-text-secondary mb-0">
                  Select a setting category from the sidebar to get started.
                </p> */}
                <Typography className="text-text-secondary mb-0" component="p">
                  Select a setting category from the sidebar to get started.
                </Typography>
              </div>
            </div>
          }
        />
        <Route
          path="project-management/create-project"
          element={<ComingSoon title="Create Project" icon={RiSettingsLine} />}
        />
        <Route
          path="project-management/edit-project"
          element={<ComingSoon title="Edit Project" icon={RiSettingsLine} />}
        />
        <Route
          path="project-management/archive-project"
          element={<ComingSoon title="Archive Project" icon={RiSettingsLine} />}
        />
      </Routes>
    </div>
  );
};

export default Settings;
